
import { parseTextNumber } from 'ice.fo.utils/NumberUtils';
const NewRetirementToolResult = () =>
  import('~/components/Finance/NewRetirementToolResult.vue');
const RetirementLineChart = () =>
  import('~/components/Finance/RetirementLineChart.vue');

export default {
  components: { NewRetirementToolResult, RetirementLineChart },
  data() {
    return {
      model: {
        lifeCost: this.$formatTextNumber(350000000),
        currentAge: 30,
        retireAge: 40,
        hellAge: 80,
        working: 10,
        inflation: 3,
        yearWillDeath: 30,
        initAmount: this.$formatTextNumber(400000000),
        amountMore: this.$formatTextNumber(200000000),
        interest: 5,
        ruleOneInterest: 15,
      },
      // savingEnoughMoney: null,
      // ruleOneEnoughMoney: null,
    };
  },

  computed: {
    tempInterest() {
      return this.model?.interest;
    },

    tempInflation() {
      return this.model?.inflation;
    },

    // this.model.working
    duringWorking() {
      return this.model.retireAge - this.model.currentAge;
    },

    duringRetirement() {
      return this.model.hellAge - this.model.retireAge;
    },

    totalYearFromNow() {
      return this.model.hellAge - this.model.currentAge;
    },

    parseLifeCost() {
      return parseTextNumber(this.model.lifeCost);
    },

    parseInitAmount() {
      return parseTextNumber(this.model.initAmount);
    },

    parseAmountMore() {
      return parseTextNumber(this.model.amountMore);
    },

    totalInvestAmountFromYearToDie() {
      let present = this.parseInitAmount;
      const additionAmountEachYear = this.parseAmountMore;

      for (let i = 1; i <= this.totalYearFromNow; i++) {
        if (i != 1) {
          present += additionAmountEachYear;
        }
      }
      return present;
    },

    savingNetInterest() {
      return (this.tempInterest - this.tempInflation) / 100;
    },

    ruleOneNetInterest() {
      return (this.model.ruleOneInterest - this.tempInflation) / 100;
    },

    savingCapitalAvailableToInvestAtRetirement() {
      const value = this.FV(
        this.savingNetInterest,
        this.duringWorking,
        this.parseAmountMore,
        this.parseInitAmount,
        0
      );

      return Math.abs(value);
    },

    costLifeUntilDie() {
      const value = this.featureValueByYear(
        this.parseLifeCost,
        this.model.inflation / 100,
        this.duringWorking
      );
      return Math.abs(value);
    },

    yourNumber() {
      const value = this.getAmountYears(
        this.parseLifeCost,
        this.model.inflation / 100,
        this.totalYearFromNow
      );

      return value;
    },

    ruleOneCapitalAvailableToInvestAtRetirement() {
      const value = this.FV(
        this.ruleOneNetInterest,
        this.duringWorking,
        this.parseAmountMore,
        this.parseInitAmount,
        0
      );

      return Math.abs(value);
    },

    savingEnoughMoney() {
      return this.getFromInvest(
        this.parseInitAmount,
        this.parseAmountMore,
        this.savingNetInterest
      );
    },

    ruleOneEnoughMoney() {
      return this.getFromInvest(
        this.parseInitAmount,
        this.parseAmountMore,
        this.ruleOneNetInterest
      );
    },
  },

  mounted() {
    // this.$modal.show('example')
    // this.$modal.show(DailyModal)
  },

  methods: {
    FV(rateInflation, yearKeepWorking, lifeCost, pv, type) {
      const pow = Math.pow(1 + rateInflation, yearKeepWorking);
      let fv;
      if (rateInflation) {
        fv =
          (lifeCost * (1 + rateInflation * type) * (1 - pow)) / rateInflation -
          pv * pow;
      } else {
        fv = -1 * (pv + lifeCost * yearKeepWorking);
      }
      return fv.toFixed(2);
    },

    PV(rate, nper, pmt) {
      return (pmt / rate) * (1 - Math.pow(1 + rate, -nper));
    },

    // https://www.dnse.com.vn/hoc/can-bao-nhieu-tien-de-nghi-huu-som
    // F = P x (1+t)^n = P x Math.pow(1+t, n)

    // Trong đó:

    // F: Số tiền chi tiêu trong tương lai
    // P: Số tiền chi tiêu trong hiện tại
    // t: tỷ lệ lạm phát mỗi năm
    // n: số năm

    featureValueByYear(present, inflation, years) {
      const value = present * Math.pow(1 + inflation, years);
      // console.log(present, inflation, years, value)
      return value;
    },

    // Giả sử bạn đang 30 tuổi, định nghỉ hưu 40 tuổi, sống đến 80 tuổi
    // Cần tính chi phí trong vòng 50 năm và lợi nhuận trong vòng 50 năm
    getAmountYears(present, inflation, totalYear) {
      let total = 0;
      const costYears = [];
      for (let i = 1; i <= totalYear; i++) {
        const eachYearValue = this.featureValueByYear(present, inflation, i);
        // console.log(present, inflation, i, eachYearValue)
        total += eachYearValue;
        costYears.push({ key: i, value: eachYearValue });
      }

      return {
        total,
        costYears,
      };
    },

    getFromInvest(init, add, rate) {
      let total = init;
      let amountEachYear = 0;
      const years = [];
      for (let i = 0; i < this.totalYearFromNow; i++) {
        let amountEachYearInterest = 0;

        if (i != 0) {
          amountEachYear = init + i * add;
          amountEachYearInterest = amountEachYear * rate;
          // console.log(present, inflation, i, eachYearValue)
          total += add;
          total += amountEachYearInterest;
        } else {
          amountEachYearInterest = init * rate;
          total += amountEachYearInterest;
        }
        years.push({ key: i + 1, value: total });
        // console.log(total, i, amountEachYear, amountEachYearInterest)
      }

      return {
        total,
        years,
      };
    },
  },
};
